import { render, staticRenderFns } from "./notaManual.vue?vue&type=template&id=8f8830c8"
import script from "./notaManual.vue?vue&type=script&lang=js"
export * from "./notaManual.vue?vue&type=script&lang=js"
import style0 from "./notaManual.vue?vue&type=style&index=0&id=8f8830c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports